"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityToggle = exports.EntityToggleDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var toggle_1 = require("../elements/toggle");
var icon_1 = require("../elements/icon");
var use_icons_1 = require("../../hooks/use-icons");
var use_entity_definition_named_1 = require("../../hooks/use-entity-definition-named");
var cell_label_1 = require("../elements/cell-label");
exports.EntityToggleDefaultProps = {
  isOn: true,
  iconSize: 32,
  fontSize: 12,
  isHalfOn: false,
  onClick: function () {}
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    ", "\n  "], ["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    ", "\n  "])), function (props) {
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      font-size: ", ";\n    "], ["\n      font-size: ", ";\n    "])), theme_1.theme.FONT_SIZE(props.fontSize));
  })
});
var IconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-right: ", ";\n    flex-shrink: 0;\n  "], ["\n    margin-right: ", ";\n    flex-shrink: 0;\n  "])), theme_1.theme.UNIT(1))
});
var ToggleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var IconAndToggleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "])))
});
// const LabelStyles = breakpoints({
//   base: css`
//     font-size: 1.0em;
//     display: flex;
//     justify-content: center;
//     margin-top: ${theme.UNIT(2)};
//     white-space: nowrap;
//   `,
// });
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", "\n    font-size: 0.9em;\n    height: 20px;\n    font-weight: 400;\n    border-radius: 20px;\n    display: flex;\n    padding-left: ", ";\n    text-transform: uppercase;\n    align-items: center;\n    justify-content: center;\n    display: none;\n  "], ["\n    ", "\n    font-size: 0.9em;\n    height: 20px;\n    font-weight: 400;\n    border-radius: 20px;\n    display: flex;\n    padding-left: ", ";\n    text-transform: uppercase;\n    align-items: center;\n    justify-content: center;\n    display: none;\n  "])), function (props) {
    return (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), theme_1.theme.COLOR(props.isOn ? 'primary' : 'textDisabled'));
  }, theme_1.theme.UNIT(1)),
  tablet: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  IconAndToggle: styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), IconAndToggleStyles),
  Icon: (0, styled_components_1.default)(icon_1.Icon)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  Toggle: (0, styled_components_1.default)(toggle_1.Toggle)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ToggleStyles),
  Label: (0, styled_components_1.default)(cell_label_1.CellLabel)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles)
};
var EntityToggle = function (props) {
  var className = props.className,
    isOn = props.isOn,
    onClick = props.onClick,
    entityTypeName = props.entityTypeName,
    children = props.children,
    title = props.title,
    iconSize = props.iconSize,
    fontSize = props.fontSize;
  var definition = (0, use_entity_definition_named_1.useEntityDefinitionNamed)(entityTypeName);
  var icons = (0, use_icons_1.useIcons)();
  if (!definition) {
    return null;
  }
  var Icon = definition.icon({
    icons: icons
  });
  return react_1.default.createElement(My.Container, {
    fontSize: fontSize,
    onClick: onClick,
    title: title,
    className: className
  }, react_1.default.createElement(My.Icon, {
    color: isOn ? "primary" : 'textDisabled',
    size: iconSize
  }, react_1.default.createElement(Icon, null)), react_1.default.createElement(My.Label, {
    isOn: isOn
  }, definition.pluralLabel));
};
exports.EntityToggle = EntityToggle;
exports.EntityToggle.defaultProps = exports.EntityToggleDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;